import React from "react";
import DrawerComponent from 'components/HOCs/MenuNav/DrawerComponent/DrawerComponent';
import DesktopNav from 'components/HOCs/MenuNav/DesktopNav/DesktopNav';
import './MenuNav.scss'

const Menu = ({onAuth, setAuth, routes}) => {
	return (
		<div className="header">
			<DrawerComponent routes={routes} setAuth={setAuth} onAuth={onAuth} />
			<DesktopNav setAuth={setAuth} onAuth={onAuth} />
		</div>
	);
};

export default Menu;
